<template>
    <fragment>
        <div
            v-if="length"
            class="List"
        >
            <ImportItem
                v-for="(item, index) in items"
                :key="index"
                v-bind="item"
                #actions
            >
                <div
                    v-if="(item.actions || []).length"
                    class="flex row-center"
                >
                    <WLink
                        v-for="(action, actionIndex ) in item.actions"
                        :key="`action-${actionIndex}`"
                        v-bind="action"
                        :class="{ 'ml-1': !!actionIndex }"
                        :disabled="isDisabled(item, action)"
                        @click.prevent="$emit(action.event, item)"
                    >
                        {{ action.label }}
                    </WLink>
                </div>
            </ImportItem>
        </div>
        <div
            v-else
            class="Empty flex col-center"
        >
            <EmptyList
                :title="$t('imports.empty.title')"
                :text="$t('imports.empty.text')"
            >
                <template #footer>
                    <WButton
                        class="mt-1"
                        @click="$emit('onNewImport')"
                    >
                        {{ $t('imports.createImport') }}
                    </WButton>
                </template>
            </EmptyList>
        </div>
    </fragment>
</template>

<script>
import VueTypes from 'vue-types'
import { EmptyList } from '@/components'
import ImportItem from '../ImportItem/ImportItem.vue'

export default {
    name: 'ImportList',
    components: {
        EmptyList,
        ImportItem,
    },
    props: {
        items: VueTypes.array,
        loading: VueTypes.bool,
    },
    computed: {
        length () {
            return (this.items || []).length
        },
    },
    methods: {
        /**
         * Si no existe el fichero, el botón "Descargar" está deshabilitado.
         * @param {integer} fileUploadId Identificador del fichero. Si no existe, el valor es "null".
         * @param {string} label Nombre del botón.
         * @returns {boolean} [True:Botón desactivado|False:Botón activado]
         */
        isDisabled ({ fileUploadId }, { label }) {
            return label === 'Download' && fileUploadId === null
        },
    },
}
</script>

<style lang="scss" scoped>
.ImportList {
    .ImportItem + .ImportItem {
        border-top: 1px solid $gray-05;
    }
}

.Empty {
    position: absolute;
    width: 100%;
    height: 100%;

    &::v-deep .EmptyList {
        flex-grow: 0;
    }
}
</style>
